// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './footer.css';

export default class Footer extends PureComponent {
    static propTypes = {
    }

    render() {
        return (
            <footer className='footer'>
                <p><span className='footer__copy'>&copy;</span> My Development Space 2017. All rights reserved</p>
                <p><a href={'/mds_privacy_policy.pdf'} target={'_blank'}>Terms & Conditions - Privacy Policy</a></p>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js